<template>
  <Teleport to="body">
    <div class="page-loader-wrapper" :class="{ 'page-loader--visible': isLoading }" aria-hidden="true">
      <div class="page-loader-bar" />
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { usePageLoader } from '@/composables/ui/usePageLoader'

const { isLoading } = usePageLoader()
</script>

<style scoped>
.page-loader-wrapper {
  @apply fixed top-0 left-0 right-0 z-[200] h-[3px] pointer-events-none opacity-0;
  transition: opacity 0.2s ease;
}

.page-loader--visible {
  @apply opacity-100;
}

.page-loader-bar {
  @apply h-full w-full;
  background: linear-gradient(
    90deg,
    rgb(var(--color-primary-light-DEFAULT)) 0%,
    rgb(var(--color-primary-light-hover)) 50%,
    rgb(var(--color-primary-light-DEFAULT)) 100%
  );
  animation: page-loader-slide 1.4s ease-in-out infinite;
  transform-origin: left;
}

:root.dark .page-loader-bar {
  background: linear-gradient(
    90deg,
    rgb(var(--color-primary-dark-DEFAULT)) 0%,
    rgb(var(--color-primary-dark-hover)) 50%,
    rgb(var(--color-primary-dark-DEFAULT)) 100%
  );
}

@keyframes page-loader-slide {
  0% {
    transform: translateX(-100%) scaleX(0.3);
  }
  40% {
    transform: translateX(0%) scaleX(0.6);
  }
  70% {
    transform: translateX(20%) scaleX(0.8);
  }
  100% {
    transform: translateX(100%) scaleX(0.2);
  }
}
</style>
